import { Component, Input } from "@angular/core";

@Component({
  selector: "app-labeled-container",
  standalone: true,
  imports: [],
  templateUrl: "./labeled-container.component.html",
  styleUrl: "./labeled-container.component.scss",
})
export class LabeledContainerComponent {
  @Input() label: string | null = null;
}
